import { Navigation } from '@griegconnect/krakentools-react-kraken-app'

import { routes as privateRoutes } from './private/Routes'
import { AccessDependencies } from '../setup/AppNavigation'

export const applicationRoutes: Navigation.Item<AccessDependencies>[] = [...privateRoutes]
